import type { Solution } from "../Solution.js";
import type { Tenant } from "../Tenant.js";
import { getServicesSolutionsPath } from "./getServicesSolutionsPath.js";

export function getServicesSolutionsDetailPath(tenant: Tenant, solution: Pick<Solution, "urlSlug">): string {
	return `${getServicesSolutionsPath(tenant)}/${solution.urlSlug}`;
}
